import { downloadXLSFile, postRequest, getRequest, putRequest, deleteRequest } from '../config/auth';
import {
	CREATE_KPI,
	LIST_DEFAULT_KPI,
	UPDATE_KPI,
	KPI_DR_SEARCH,
	DELETE_KPI,
	KPI_DR_VIEW,
	KPI_PROGRESS,
	EXPORT_MY_KPI_REPORT,
	UPDATE_MY_KPI_DESCRIPTION,
	KPI_PENDING_APPROVAL_LIST,
	KPI_APPROVAL_REQUEST,
	KPI_PERFORMANCE_SNAPSHOT_PROCESS,
} from '../config/api-url';

export const createDefaultKpiAPI = (data) => postRequest(`${CREATE_KPI}`, data);
export const listDefaultOkrAPI = (data) => postRequest(`${LIST_DEFAULT_KPI}`, data);
export const updateDefaultKpiAPI = (data) => putRequest(`${UPDATE_KPI}`, data);
export const searchKpiUserAPI = (data) => getRequest(`${KPI_DR_SEARCH}?${data}`, data);
export const deleteKpi = (data) => deleteRequest(`${DELETE_KPI}?${data}`, data);
export const myKpiDrAPI = (data) => postRequest(`${KPI_DR_VIEW}`, data);
export const kpiProgressAPI = (data) => getRequest(`${KPI_PROGRESS}?${data}`, data);
export const exportMyKpiReportAPI = (data) => downloadXLSFile(`${EXPORT_MY_KPI_REPORT}?${data}`, data);
export const updateKpiDescriptionAPI = (requestParam, data) =>
	putRequest(`${UPDATE_MY_KPI_DESCRIPTION}?${requestParam}`, data);
export const getKpiPendingApprovalListAPI = (data) => postRequest(`${KPI_PENDING_APPROVAL_LIST}`, data);
export const approveKpiAPI = (data) => postRequest(`${KPI_APPROVAL_REQUEST}`, data);
export const getKpiProgressStatusAndPerformanceAPI = (data) =>
	getRequest(`${KPI_PERFORMANCE_SNAPSHOT_PROCESS}?${data}`, data);
